const getApiUrl = () => {
  // CloudFlare CDN integration - Force cache refresh v2
  // First check if API URL is set in environment variables
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Fallback to default development URLs
  if (process.env.NODE_ENV === 'development') {
    // Check if accessing from mobile browser
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      return 'http://192.168.86.42:3000'; // Your IP address
    }
    return 'http://localhost:3000';
  }
  
  // Fallback production URL
  return 'https://quisqueya-quest-prod-78ec2003f8a1.herokuapp.com';
};

const config = {
  API_URL: getApiUrl(),
};

console.log('Web config initialized:', {
  environment: process.env.NODE_ENV,
  API_URL: config.API_URL,
  userAgent: navigator.userAgent,
});

export default config; // Force rebuild with new REACT_APP_API_URL: Mon Jun 23 20:30:35 AST 2025
// Cache bust: 1758734542
